import React from "react";

import { VISIT_TYPES, VisitType } from "~/services";
import { CoachVisitForm, FollowUpVisitForm, InitialVisitForm } from ".";
import { PersonalInformationFormData } from "../validation/schema";

type PersonalInformationFormProps = {
  visitType: VisitType;
  onSubmit: (data: PersonalInformationFormData) => void;
  isLoading?: boolean;
};

export const PersonalInformationForm = ({
  visitType,
  onSubmit,
  isLoading = false,
}: PersonalInformationFormProps) => {
  const handleFormSubmit = (data: any) => {
    onSubmit(data as PersonalInformationFormData);
  };

  const visitTypeComponents = {
    [VISIT_TYPES.INITIAL]: InitialVisitForm,
    [VISIT_TYPES.FOLLOW_UP]: FollowUpVisitForm,
    [VISIT_TYPES.COACH]: CoachVisitForm,
  } as const;

  const FormComponent =
    visitTypeComponents[visitType as keyof typeof visitTypeComponents] ||
    InitialVisitForm;

  return <FormComponent onSubmit={handleFormSubmit} isLoading={isLoading} />;
};
